import { createRoute } from '@tanstack/react-router'
import { Route as appLayoutRoute } from '../../layout'

export const Route = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: '/admin/roles/$roleId',
}).lazy(() => import('./$roleId.index.lazy').then((d) => d.Route))
